export default "__VITE_ASSET__DZ0A_Efi__"